import { render, staticRenderFns } from "./ePharmacyClinical.vue?vue&type=template&id=52a04b72&"
import script from "./ePharmacyClinical.vue?vue&type=script&lang=js&"
export * from "./ePharmacyClinical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports